import React, { useEffect, useState } from 'react';
import { ContactForm } from './ContactForm';
import Meta from './Meta';

export default function PrivateSector() {
  const [tariffs, setTariffs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTariff, setActiveTariff] = useState(null); 

  useEffect(() => {
    fetch('https://api.itosoba.ru/api/tariffs/')
      .then(res => {
        if (!res.ok) throw new Error('Ошибка загрузки тарифов');
        return res.json();
      })
      .then(data => {
        setTariffs(data);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  const regions = Array.from(new Set(tariffs.map(t => t.region))).sort();

  const filteredTariffs = selectedRegion
    ? tariffs.filter(t => t.region === selectedRegion)
    : tariffs;

  function openModal(tariff) {
    setActiveTariff(tariff);
    setIsModalOpen(true);
  }

  function closeModal() {
    setIsModalOpen(false);
    setActiveTariff(null);
  }

  if (loading) return <p style={{ padding: 20 }}>Загрузка тарифов...</p>;
  if (error) return <p style={{ padding: 20, color: 'red' }}>Ошибка: {error}</p>;

  return (
   <React.Fragment>
  <Meta
     title="Подключить интернет в частный дом за городом — решение для коттеджных поселков"
     description="Подключение интернета в частных домах и коттеджах с гарантией качества в Московской области (Подольск, Александровка, КП Бор-11, Валищево, Ветеран, Колос, Висячий мост, д. Кучино, д. Крюково, КП Медная подкова, д. Меньшово, Нива-2, Молодцы, Овчинки, Петровская слобода, д. Покров, д. Поливаново, СНТ ПЭМЗ-1, СНТ Радуга, КП Фаворит, д. Щербинка, КП Берег, СНТ Поляны и т.д.)"
   />
    <div style={{ padding: 20 }}>
      <style>{`
        .tariff-grid {
          display: grid;
          gap: 20px;
          justify-content: center;
          max-width: 1300px;
          margin: 0 auto;
          grid-template-columns: repeat(1, 1fr);
        }
        @media (min-width: 480px) {
          .tariff-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        @media (min-width: 768px) {
          .tariff-grid {
            grid-template-columns: repeat(3, 1fr);
          }
        }
        @media (min-width: 1024px) {
          .tariff-grid {
            grid-template-columns: repeat(4, 1fr);
          }
        }
        @media (min-width: 1300px) {
          .tariff-grid {
            grid-template-columns: repeat(5, 1fr);
          }
        }
        .tariff-card {
          border: 1px solid #ccc;
          padding: 20px;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          min-height: 320px;
          background-color: #fff;
          font-size: 16px;
          transition: box-shadow 0.3s;
        }
        .tariff-card:hover {
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        }
        .connect-button {
          background-color: #4CAF50;
          color: white;
          padding: 12px 24px;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          font-size: 18px;
          margin-top: 16px;
          transition: background-color 0.3s, box-shadow 0.3s;
        }
        .connect-button:hover {
          background-color: #45a049;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        }
      `}</style>
      
      
      <h1
        style={{
          textAlign: 'center',
          marginBottom: '30px',
          color: '#2c3e50',
        }}
      >
        Интернет в частный сектор: тарифы и цены на подключение загородного дома/дачи
      </h1>
      

      <div style={{ marginBottom: 20 }}>
        <label htmlFor="regionFilter">Фильтр по району: </label>
        <select
          id="regionFilter"
          value={selectedRegion}
          onChange={e => setSelectedRegion(e.target.value)}
        >
          <option value="">Все районы</option>
          {regions.map(region => (
            <option key={region} value={region}>{region}</option>
          ))}
        </select>
      </div>

      {filteredTariffs.length === 0 && <p>Нет тарифов для выбранного региона</p>}

      <div className="tariff-grid">
        {filteredTariffs.map((tariff, index) => (
          <div key={tariff.id} className="tariff-card">
            <div>
              <h2 style={{ marginTop: 0, fontSize: 18 }}>
                {index + 1}) {tariff.region}
              </h2>
              <p>
                <strong>Подключение:</strong>{' '}
                {tariff.connection_fee ? `${tariff.connection_fee} р` : '–'}
              </p>
              <p>
                <strong>Авансовый платеж:</strong>{' '}
                {tariff.advance_payment ? `${tariff.advance_payment} р` : '–'}
              </p>

              {[1, 2, 3, 4, 5].map(i => {
                const speed = tariff[`speed${i}`];
                const price = tariff[`price${i}`];
                if (!speed || !price) return null;
                return (
                  <p key={i} style={{ margin: '4px 0' }}>
                    Скорость:<br />
                    {speed} Мб/с — {price} р/мес
                  </p>
                );
              })}
            </div>

            {/* <button
              onClick={() => openModal(tariff)}
              className="connect-button"
              aria-label={`Подключить тариф ${tariff.region}`}
            >
              Подключить
            </button> */}
          </div>
        ))}
      </div>

      {isModalOpen && (
        <div
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
            alignItems: 'center', justifyContent: 'center',
            zIndex: 9999,
          }}
          onClick={closeModal}
        >
          <div
            style={{
              backgroundColor: '#fff',
              padding: 20,
              borderRadius: 8,
              width: '90%',
              maxWidth: 400,
              maxHeight: '90%',
              overflowY: 'auto',
              position: 'relative',
            }}
            onClick={e => e.stopPropagation()}
          >
            <div
              style={{
                position: 'absolute',
                top: 12,
                right: 12,
                width: 32,
                height: 32,
                cursor: 'pointer',
                borderRadius: '50%',
                backgroundColor: '#f0f0f0',
                color: '#333',
                fontSize: 24,
                fontWeight: 'bold',
                lineHeight: '32px',
                textAlign: 'center',
                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                transition: 'background-color 0.3s, color 0.3s, box-shadow 0.3s',
                userSelect: 'none',
              }}
              onClick={closeModal}
              aria-label="Закрыть"
              onMouseEnter={e => {
                e.currentTarget.style.backgroundColor = '#e0e0e0';
                e.currentTarget.style.color = '#000';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.backgroundColor = '#f0f0f0';
                e.currentTarget.style.color = '#333';
                e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)';
              }}
              onMouseDown={e => {
                e.currentTarget.style.backgroundColor = '#d0d0d0';
                e.currentTarget.style.boxShadow = 'inset 0 2px 4px rgba(0,0,0,0.2)';
              }}
              onMouseUp={e => {
                e.currentTarget.style.backgroundColor = '#e0e0e0';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
              }}
            >
              ×
            </div>

            <h3>Подключить тариф: <br />{activeTariff.region}</h3>
               <ContactForm />
          </div>
        </div>
      )}
    </div>
    </React.Fragment>
  );
}